import React from 'react';
import { DynamicVideoPlayer } from '@components/video-player/DynamicVideoPlayer';
import { ImageCaption } from '@components/ImageCaption';
import { CloudinaryVideoType, CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import * as S from './Video.styles';

export interface Props {
  value: { video: CloudinaryVideoType; videoThumbnail?: CloudinaryImageType };
}

export const VideoBlock = ({ value: { video } }: Props) => (
  <S.VideoWrapper>
    <DynamicVideoPlayer video={video} />
    {video?.caption && <ImageCaption caption={video.caption} />}
  </S.VideoWrapper>
);

export const ArticleVideoBlock = ({ value: { video, videoThumbnail } }: Props) => (
  <S.ArticleWrapper className="videoBlock">
    <S.ArticleVideoGridCol>
      <DynamicVideoPlayer video={video} image={videoThumbnail} />
    </S.ArticleVideoGridCol>
    {video?.caption && (
      <S.ArticleVideoCaptionGridCol $captionMode="text-right">
        <ImageCaption caption={video.caption} />
      </S.ArticleVideoCaptionGridCol>
    )}
  </S.ArticleWrapper>
);
